var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "scale(25)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.73 36.98V3.008c0-.633-.51-1.143-1.153-1.143H7.815c-.642 0-1.152.51-1.152 1.143V36.98c0 .633.51 1.152 1.152 1.152h6.762c.643 0 1.153-.51 1.153-1.152M33.12 36.98V3.008c0-.633-.51-1.143-1.152-1.143h-6.762c-.642 0-1.152.51-1.152 1.143V36.98c0 .633.51 1.152 1.152 1.152h6.762c.642 0 1.152-.51 1.152-1.152"
  }))));
};
export default SvgPauseIcon;